<template>
    <div class="mt-3">
        <div class="text-secondary text-center">
            <div v-if="user" class=  "text-center">
            Welcome back <span class = "front-weight-bold text-info">{{user.displayName}}</span>, 
            <a href="#" role="button" class = "text-primary" @click = "$emit('logout')">Logout </a>

            </div>

        </div>
        <div class="container text-center">
        <div class="row justify-content-center">
        <div class="col-10 col-md-10 col-lg-8 col-xl-7">
            <h4 class="display-4 text-primary mt-3 mb-2">Meeting Board</h4>
            <p class="lead">
            Meeting Board allows users to create meetings, to check in, and
            picks random users to award giveaways. This is Vuong's second 
            <a href="https://vuejs.org/">Vue.js</a> project
           and first project with
            <a href="https://firebase.google.com">Firebase</a>.
            
            <FontAwesomeIcon class="text-danger" icon="star"></FontAwesomeIcon>
            </p>

            <router-link
            class="btn btn-outline-primary mr-2"
            to="/register"
            v-if="!user"
            >Register</router-link>
            
            <router-link
            class="btn btn-outline-primary mr-2"
            to="/login"
            v-if="!user"
            >Log In</router-link
            
            >
            <router-link
            class="btn btn-primary"
            to="/meetings"
            v-if="user"
            >Meetings</router-link>
        </div>
        </div>
        </div>
    </div>  
</template>

<script>

import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
export default {
    name: "home",
    props: ["user"],
    data: function(){
        return {
            
        }
    },
    components: {
        FontAwesomeIcon
    }
    
}
</script>